import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
var _class;
import { Component } from 'react';
import { TipContainer, observer } from '@alilc/lowcode-editor-core';
import classNames from 'classnames';
import TopArea from './top-area';
import LeftArea from './left-area';
import LeftFixedPane from './left-fixed-pane';
import LeftFloatPane from './left-float-pane';
import Toolbar from './toolbar';
import MainArea from './main-area';
import BottomArea from './bottom-area';
import RightArea from './right-area';
import './workbench.less';
import { SkeletonContext } from '../context';
export var Workbench = observer(_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Workbench, _Component);
  function Workbench(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    var _this$props = _this.props,
      config = _this$props.config,
      components = _this$props.components,
      skeleton = _this$props.skeleton;
    skeleton.buildFromConfig(config, components);
    return _this;
  }
  var _proto = Workbench.prototype;
  _proto.render = function render() {
    var _this$props2 = this.props,
      skeleton = _this$props2.skeleton,
      className = _this$props2.className,
      topAreaItemClassName = _this$props2.topAreaItemClassName;
    return /*#__PURE__*/React.createElement("div", {
      className: classNames('lc-workbench', className)
    }, /*#__PURE__*/React.createElement(SkeletonContext.Provider, {
      value: this.props.skeleton
    }, /*#__PURE__*/React.createElement(TopArea, {
      area: skeleton.topArea,
      itemClassName: topAreaItemClassName
    }), /*#__PURE__*/React.createElement("div", {
      className: "lc-workbench-body"
    }, /*#__PURE__*/React.createElement(LeftArea, {
      area: skeleton.leftArea
    }), /*#__PURE__*/React.createElement(LeftFloatPane, {
      area: skeleton.leftFloatArea
    }), /*#__PURE__*/React.createElement(LeftFixedPane, {
      area: skeleton.leftFixedArea
    }), /*#__PURE__*/React.createElement("div", {
      className: "lc-workbench-center"
    }, /*#__PURE__*/React.createElement(Toolbar, {
      area: skeleton.toolbar
    }), /*#__PURE__*/React.createElement(MainArea, {
      area: skeleton.mainArea
    }), /*#__PURE__*/React.createElement(BottomArea, {
      area: skeleton.bottomArea
    })), /*#__PURE__*/React.createElement(RightArea, {
      area: skeleton.rightArea
    })), /*#__PURE__*/React.createElement(TipContainer, null)));
  };
  return Workbench;
}(Component)) || _class;